import { openBlock, createElementBlock, createElementVNode, defineComponent, ref, useSlots, onErrorCaptured, unref, Fragment, renderSlot, createBlock, resolveDynamicComponent, normalizeProps, mergeProps } from "vue";
var _export_sfc = (sfc, props) => {
  for (const [key, val] of props) {
    sfc[key] = val;
  }
  return sfc;
};
const _sfc_main$1 = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("h1", null, "Something went wrong!", -1);
const _hoisted_2 = /* @__PURE__ */ createElementVNode("p", null, "Please try again.", -1);
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("div", null, _hoisted_3);
}
var DefaultFallback = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render]]);
const _sfc_main = /* @__PURE__ */ defineComponent({
  props: {
    fallBack: { type: null, required: false, default: DefaultFallback },
    onError: { type: Function, required: false, default: () => {
    } },
    params: { type: Object, required: false, default: () => ({}) },
    stopPropagation: { type: Boolean, required: false, default: false }
  },
  emits: ["error-captured"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const hasError$ = ref(false);
    const err$ = ref(null);
    const info$ = ref("");
    const slots = useSlots();
    if (!slots.default && !slots.boundary) {
      console.warn("ErrorBoundary component must have child components.");
    }
    onErrorCaptured((error, vm, info) => {
      hasError$.value = true;
      err$.value = error;
      info$.value = info;
      props == null ? void 0 : props.onError(error, vm, info);
      emits("error-captured", { error, vm, info });
      if (props.stopPropagation)
        return false;
    });
    return (_ctx, _cache) => {
      return !unref(slots).boundary ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        !hasError$.value ? renderSlot(_ctx.$slots, "default", { key: 0 }) : (openBlock(), createBlock(resolveDynamicComponent(props.fallBack), normalizeProps(mergeProps({ key: 1 }, __props.params)), null, 16))
      ], 64)) : renderSlot(_ctx.$slots, "boundary", mergeProps({
        key: 1,
        hasError: hasError$.value,
        error: err$.value,
        info: info$.value
      }, __props.params));
    };
  }
});
export { _sfc_main as default };
